import React, { useState, useEffect, useCallback } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  MessageBox,
  UpdateButton,
  ResetButton,
  Dropdown,
  NumberInput,
  Legend,
  Switch,
} from "../../../components/FormElements";
import API from "../../../api";
import { API_RESPONSE_TYPES } from "../../../constants";
import { StyledSwitchOuter } from "../../../components/Styled";

const AppConfiguration = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  // Login Configuration
  const [twofaStatus, setTwofaStatus] = useState("Active");

  // Maintenance
  const [apiSystemMaintenance, setApiSystemMaintenance] = useState("Active");
  const [webSystemMaintenance, setWebSystemMaintenance] = useState("Active");

  // GST Configuration
  const [gstWalletStatus, setGstWalletStatus] = useState("Active");
  const [nonGstWalletStatus, setNonGstWalletStatus] = useState("Active");
  const [gstInvoiceP2PStatus, setGstInvoiceP2PStatus] = useState("Active");
  const [gstInvoiceP2AStatus, setGstInvoiceP2AStatus] = useState("Active");

  // Recharge Configuration
  const [maxRechargeApiHits, setMaxRechargeApiHits] = useState("");
  const [callbackRechargeProcessingTime, setCallbackRechargeProcessingTime] =
    useState("");
  const [complaintRatioAllowed, setComplaintRatioAllowed] = useState("100");
  const [complaintCalculationPeriod, setComplaintCalculationPeriod] =
    useState("");
  const [callbackCalculationPeriod, setCallbackCalculationPeriod] =
    useState("");
  const [rofferCheck, setRofferCheck] = useState("Active");
  const [operatorValidation, setOperatorValidation] = useState("Active");
  const [maxPendingRecharges, setMaxPendingRecharges] = useState("");
  const [duplicateTransactionsGap, setDuplicateTransactionsGap] = useState("");
  const [pendingStatusCheckTime, setPendingStatusCheckTime] = useState("");
  const [fakeComplaintPenality, setFakeComplaintPenality] = useState("");

  // Payment Gateway Configuration
  const [paymentGatewayStatus, setPaymentGatewayStatus] = useState("Active");
  const [paymentGatewayMinAmount, setPaymentGatewayMinAmount] = useState("0");
  const [paymentGatewayMaxAmount, setPaymentGatewayMaxAmount] = useState("0");

  // Wallet Configuration
  const [complaintHoldDays, setComplaintHoldDays] = useState("");
  const [sellerAmountHoldPercentage, setSellerAmountHoldPercentage] =
    useState("");
  const [timeBetweenRedeem, setTimeBetweenRedeem] = useState("");
  const [minAutoWalletTransferAmount, setMinAutoWalletTransferAmount] =
    useState("0");
  const [timeBetweenAutoWalletTransfer, setTimeBetweenAutoWalletTransfer] =
    useState("0");
  const [autoWalletTransferStatus, setAutoWalletTransferStatus] =
    useState("Active");
  const [timeBetweenComplaints, setTimeBetweenComplaints] = useState("");
  const [redeemStatus, setRedeemStatus] = useState("Active");
  const [redeemSameAmountGap, setRedeemSameAmountGap] = useState("");
  const [minimumRedeemAmountLimit, setMinimumRedeemAmountLimit] = useState("");
  const [maximumRedeemAmountLimit, setMaximumRedeemAmountLimit] = useState("");
  const [walletTopUpSameAmountGap, setWalletTopUpSameAmountGap] = useState("");

  // Seller Configuration
  const [sellersMaxAllowedApis, setSellersMaxAllowedApis] = useState("");
  const [sellersAPIEditStatus, setSellersAPIEditStatus] = useState("Yes");
  const [sellersAPIDeleteStatus, setSellersAPIDeleteStatus] = useState("Yes");
  const [sellersMarginEditStatus, setSellersMarginEditStatus] = useState("Yes");
  const [sellersMarginDeleteStatus, setSellersMarginDeleteStatus] =
    useState("Yes");
  const [sellersMarginUserCountStatus, setSellersMarginUserCountStatus] =
    useState("");
  const [salesMarginLimit, setSalesMarginLimit] = useState("");
  const [salesMarginUpdateGap, setSalesMarginUpdateGap] = useState("");
  const [salesMarginStockLimit, setSalesMarginStockLimit] = useState("");

  // Recharge Alerts
  const [transactionPendingWarning, setTransactionPendingWarning] =
    useState("");
  const [complaintPendingWarning, setComplaintPendingWarning] = useState("");

  // Payout Configuration
  const [bankVerificationCharges, setBankVerificationCharges] = useState("");
  const [withdrawCharges, setWithdrawCharges] = useState("");
  const [payoutStatus, setPayoutStatus] = useState("Active");

  // User Complaint Settings
  const [complaintsAllowedTime, setComplaintsAllowedTime] = useState("");
  const [complaintsAllowedCount, setComplaintsAllowedCount] = useState("");
  const [allowComplaintsAfterRecharge, setAllowComplaintsAfterRecharge] =
    useState("");

  // User Api Disable Settings
  const [apiDisableforComplaintTime, setApiDisableforComplaintTime] =
    useState("");
  const [apiDisableforPendingTime, setApiDisableforPendingTime] = useState("");

  const [buyerWalletCap, setBuyerWalletCap] = useState("");

  const [originalFormData, setOriginalFormData] = useState({});

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    const {
      // Login Configuration
      twofaStatus,

      // Maintenance
      apiSystemMaintenance,
      webSystemMaintenance,

      // GST Configuration
      gstWalletStatus,
      nonGstWalletStatus,
      gstInvoiceP2PStatus,
      gstInvoiceP2AStatus,

      // Recharge Configuration
      maxRechargeApiHits,
      callbackRechargeProcessingTime,
      complaintRatioAllowed,
      complaintCalculationPeriod,
      callbackCalculationPeriod,
      rofferCheck,
      operatorValidation,
      maxPendingRecharges,
      duplicateTransactionsGap,
      pendingStatusCheckTime,
      fakeComplaintPenality,

      // Payment Gateway Configuration
      paymentGatewayStatus,
      paymentGatewayMinAmount,
      paymentGatewayMaxAmount,

      // Wallet Configuration
      complaintHoldDays,
      sellerAmountHoldPercentage,
      timeBetweenRedeem,
      minAutoWalletTransferAmount,
      timeBetweenAutoWalletTransfer,
      autoWalletTransferStatus,
      timeBetweenComplaints,
      redeemStatus,
      redeemSameAmountGap,
      minimumRedeemAmountLimit,
      maximumRedeemAmountLimit,
      walletTopUpSameAmountGap,

      // Seller Configuration
      sellersMaxAllowedApis,
      sellersAPIEditStatus,
      sellersAPIDeleteStatus,
      sellersMarginEditStatus,
      sellersMarginDeleteStatus,
      sellersMarginUserCountStatus,
      salesMarginLimit,
      salesMarginUpdateGap,
      salesMarginStockLimit,

      // Recharge Alerts
      transactionPendingWarning,
      complaintPendingWarning,

      // Payout Configuration
      bankVerificationCharges,
      withdrawCharges,
      payoutStatus,

      // User Complaint Settings
      complaintsAllowedTime,
      complaintsAllowedCount,

      // User Api Disable Settings
      apiDisableforComplaintTime,
      apiDisableforPendingTime,
      allowComplaintsAfterRecharge,
      buyerWalletCap,
    } = originalFormData;

    // Login Configuration
    setTwofaStatus(twofaStatus);

    // Maintenance
    setApiSystemMaintenance(apiSystemMaintenance);
    setWebSystemMaintenance(webSystemMaintenance);

    // GST Configuration
    setGstWalletStatus(gstWalletStatus);
    setNonGstWalletStatus(nonGstWalletStatus);
    setGstInvoiceP2PStatus(gstInvoiceP2PStatus);
    setGstInvoiceP2AStatus(gstInvoiceP2AStatus);

    // Recharge Configuration
    setMaxRechargeApiHits(maxRechargeApiHits);
    setCallbackRechargeProcessingTime(callbackRechargeProcessingTime);
    setComplaintRatioAllowed(complaintRatioAllowed);
    setComplaintCalculationPeriod(complaintCalculationPeriod);
    setCallbackCalculationPeriod(callbackCalculationPeriod);
    setRofferCheck(setRofferCheck);
    setOperatorValidation(operatorValidation);
    setMaxPendingRecharges(maxPendingRecharges);
    setDuplicateTransactionsGap(duplicateTransactionsGap);
    setPendingStatusCheckTime(pendingStatusCheckTime);
    setFakeComplaintPenality(fakeComplaintPenality);

    // Payment Gateway Configuration
    setPaymentGatewayStatus(paymentGatewayStatus);
    setPaymentGatewayMinAmount(paymentGatewayMinAmount);
    setPaymentGatewayMaxAmount(paymentGatewayMaxAmount);

    // Wallet Configuration
    setComplaintHoldDays(complaintHoldDays);
    setSellerAmountHoldPercentage(sellerAmountHoldPercentage);
    setTimeBetweenRedeem(timeBetweenRedeem);
    setMinAutoWalletTransferAmount(minAutoWalletTransferAmount);
    setTimeBetweenAutoWalletTransfer(timeBetweenAutoWalletTransfer);
    setAutoWalletTransferStatus(autoWalletTransferStatus);
    setTimeBetweenComplaints(timeBetweenComplaints);
    setRedeemStatus(setRedeemStatus);
    setRedeemSameAmountGap(redeemSameAmountGap);
    setMinimumRedeemAmountLimit(minimumRedeemAmountLimit);
    setMaximumRedeemAmountLimit(maximumRedeemAmountLimit);
    setWalletTopUpSameAmountGap(walletTopUpSameAmountGap);

    // Seller Configuration
    setSellersMaxAllowedApis(sellersMaxAllowedApis);
    setSellersAPIEditStatus(sellersAPIEditStatus);
    setSellersAPIDeleteStatus(sellersAPIDeleteStatus);
    setSellersMarginEditStatus(sellersMarginEditStatus);
    setSellersMarginDeleteStatus(sellersMarginDeleteStatus);
    setSellersMarginUserCountStatus(sellersMarginUserCountStatus);
    setSalesMarginLimit(salesMarginLimit);
    setSalesMarginUpdateGap(salesMarginUpdateGap);
    setSalesMarginStockLimit(salesMarginStockLimit);

    // Recharge Alerts
    setTransactionPendingWarning(transactionPendingWarning);
    setComplaintPendingWarning(complaintPendingWarning);

    // Payout Configuration
    setBankVerificationCharges(bankVerificationCharges);
    setWithdrawCharges(withdrawCharges);
    setPayoutStatus(payoutStatus);

    // User Complaint Settings
    setComplaintsAllowedTime(complaintsAllowedTime);
    setComplaintsAllowedCount(complaintsAllowedCount);

    // User Api Disable Settings
    setApiDisableforComplaintTime(apiDisableforComplaintTime);
    setApiDisableforPendingTime(apiDisableforPendingTime);
    setAllowComplaintsAfterRecharge(allowComplaintsAfterRecharge);
    setBuyerWalletCap(buyerWalletCap);
  };

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/configurations/app-configuration`)
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          const {
            // Login Configuration
            twofaStatus,

            // Maintenance
            apiSystemMaintenance,
            webSystemMaintenance,

            // GST Configuration
            gstWalletStatus,
            nonGstWalletStatus,
            gstInvoiceP2PStatus,
            gstInvoiceP2AStatus,

            // Recharge Configuration
            maxRechargeApiHits,
            callbackRechargeProcessingTime,
            complaintRatioAllowed,
            complaintCalculationPeriod,
            callbackCalculationPeriod,
            rofferCheck,
            operatorValidation,
            maxPendingRecharges,
            duplicateTransactionsGap,
            pendingStatusCheckTime,
            fakeComplaintPenality,

            // Payment Gateway Configuration
            paymentGatewayStatus,
            paymentGatewayMinAmount,
            paymentGatewayMaxAmount,

            // Wallet Configuration
            complaintHoldDays,
            sellerAmountHoldPercentage,
            timeBetweenRedeem,
            minAutoWalletTransferAmount,
            timeBetweenAutoWalletTransfer,
            autoWalletTransferStatus,
            timeBetweenComplaints,
            redeemStatus,
            redeemSameAmountGap,
            minimumRedeemAmountLimit,
            maximumRedeemAmountLimit,
            walletTopUpSameAmountGap,

            // Seller Configuration
            sellersMaxAllowedApis,
            sellersAPIEditStatus,
            sellersAPIDeleteStatus,
            sellersMarginEditStatus,
            sellersMarginDeleteStatus,
            sellersMarginUserCountStatus,
            salesMarginLimit,
            salesMarginUpdateGap,
            salesMarginStockLimit,

            // Recharge Alerts
            transactionPendingWarning,
            complaintPendingWarning,

            // Payout Configuration
            bankVerificationCharges,
            withdrawCharges,
            payoutStatus,

            // User Complaint Settings
            complaintsAllowedTime,
            complaintsAllowedCount,

            // User Api Disable Settings
            apiDisableforComplaintTime,
            apiDisableforPendingTime,
            allowComplaintsAfterRecharge,

            buyerWalletCap,
          } = data;
          // Login Configuration
          setTwofaStatus(twofaStatus);

          // Maintenance
          setApiSystemMaintenance(apiSystemMaintenance);
          setWebSystemMaintenance(webSystemMaintenance);

          // GST Configuration
          setGstWalletStatus(gstWalletStatus);
          setNonGstWalletStatus(nonGstWalletStatus);
          setGstInvoiceP2PStatus(gstInvoiceP2PStatus);
          setGstInvoiceP2AStatus(gstInvoiceP2AStatus);

          // Recharge Configuration
          setMaxRechargeApiHits(maxRechargeApiHits);
          setCallbackRechargeProcessingTime(callbackRechargeProcessingTime);
          setComplaintRatioAllowed(complaintRatioAllowed);
          setComplaintCalculationPeriod(complaintCalculationPeriod);
          setCallbackCalculationPeriod(callbackCalculationPeriod);
          setRofferCheck(setRofferCheck);
          setOperatorValidation(operatorValidation);
          setMaxPendingRecharges(maxPendingRecharges);
          setDuplicateTransactionsGap(duplicateTransactionsGap);
          setPendingStatusCheckTime(pendingStatusCheckTime);
          setFakeComplaintPenality(fakeComplaintPenality);

          // Payment Gateway Configuration
          setPaymentGatewayStatus(paymentGatewayStatus);
          setPaymentGatewayMinAmount(paymentGatewayMinAmount);
          setPaymentGatewayMaxAmount(paymentGatewayMaxAmount);

          // Wallet Configuration
          setComplaintHoldDays(complaintHoldDays);
          setSellerAmountHoldPercentage(sellerAmountHoldPercentage);
          setTimeBetweenRedeem(timeBetweenRedeem);
          setMinAutoWalletTransferAmount(minAutoWalletTransferAmount);
          setTimeBetweenAutoWalletTransfer(timeBetweenAutoWalletTransfer);
          setAutoWalletTransferStatus(autoWalletTransferStatus);
          setTimeBetweenComplaints(timeBetweenComplaints);
          setRedeemStatus(setRedeemStatus);
          setRedeemSameAmountGap(redeemSameAmountGap);
          setMinimumRedeemAmountLimit(minimumRedeemAmountLimit);
          setMaximumRedeemAmountLimit(maximumRedeemAmountLimit);
          setWalletTopUpSameAmountGap(walletTopUpSameAmountGap);

          // Seller Configuration
          setSellersMaxAllowedApis(sellersMaxAllowedApis);
          setSellersAPIEditStatus(sellersAPIEditStatus);
          setSellersAPIDeleteStatus(sellersAPIDeleteStatus);
          setSellersMarginEditStatus(sellersMarginEditStatus);
          setSellersMarginDeleteStatus(sellersMarginDeleteStatus);
          setSellersMarginUserCountStatus(sellersMarginUserCountStatus);
          setSalesMarginLimit(salesMarginLimit);
          setSalesMarginUpdateGap(salesMarginUpdateGap);
          setSalesMarginStockLimit(salesMarginStockLimit);

          // Recharge Alerts
          setTransactionPendingWarning(transactionPendingWarning);
          setComplaintPendingWarning(complaintPendingWarning);

          // Payout Configuration
          setBankVerificationCharges(bankVerificationCharges);
          setWithdrawCharges(withdrawCharges);
          setPayoutStatus(payoutStatus);

          // User Complaint Settings
          setComplaintsAllowedTime(complaintsAllowedTime);
          setComplaintsAllowedCount(complaintsAllowedCount);

          // User Api Disable Settings
          setApiDisableforComplaintTime(apiDisableforComplaintTime);
          setApiDisableforPendingTime(apiDisableforPendingTime);
          setAllowComplaintsAfterRecharge(allowComplaintsAfterRecharge);

          setBuyerWalletCap(buyerWalletCap);

          setOriginalFormData({
            // Login Configuration
            twofaStatus,

            // Maintenance
            apiSystemMaintenance,
            webSystemMaintenance,

            // GST Configuration
            gstWalletStatus,
            nonGstWalletStatus,
            gstInvoiceP2PStatus,
            gstInvoiceP2AStatus,

            // Recharge Configuration
            maxRechargeApiHits,
            callbackRechargeProcessingTime,
            complaintRatioAllowed,
            complaintCalculationPeriod,
            callbackCalculationPeriod,
            rofferCheck,
            operatorValidation,
            maxPendingRecharges,
            duplicateTransactionsGap,
            pendingStatusCheckTime,
            fakeComplaintPenality,

            // Payment Gateway Configuration
            paymentGatewayStatus,
            paymentGatewayMinAmount,
            paymentGatewayMaxAmount,

            // Wallet Configuration
            complaintHoldDays,
            sellerAmountHoldPercentage,
            timeBetweenRedeem,
            minAutoWalletTransferAmount,
            timeBetweenAutoWalletTransfer,
            autoWalletTransferStatus,
            timeBetweenComplaints,
            redeemStatus,
            redeemSameAmountGap,
            minimumRedeemAmountLimit,
            maximumRedeemAmountLimit,
            walletTopUpSameAmountGap,

            // Seller Configuration
            sellersMaxAllowedApis,
            sellersAPIEditStatus,
            sellersAPIDeleteStatus,
            sellersMarginEditStatus,
            sellersMarginDeleteStatus,
            sellersMarginUserCountStatus,
            salesMarginLimit,
            salesMarginUpdateGap,
            salesMarginStockLimit,

            // Recharge Alerts
            transactionPendingWarning,
            complaintPendingWarning,

            // Payout Configuration
            bankVerificationCharges,
            withdrawCharges,
            payoutStatus,

            // User Complaint Settings
            complaintsAllowedTime,
            complaintsAllowedCount,

            // User Api Disable Settings
            apiDisableforComplaintTime,
            apiDisableforPendingTime,
            allowComplaintsAfterRecharge,

            buyerWalletCap,
          });
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      // Login Configuration
      twofaStatus,

      // Maintenance
      apiSystemMaintenance,
      webSystemMaintenance,

      // GST Configuration
      gstWalletStatus,
      nonGstWalletStatus,
      gstInvoiceP2PStatus,
      gstInvoiceP2AStatus,

      // Recharge Configuration
      maxRechargeApiHits,
      callbackRechargeProcessingTime,
      complaintRatioAllowed: complaintRatioAllowed,
      complaintCalculationPeriod,
      callbackCalculationPeriod,
      rofferCheck,
      operatorValidation,
      maxPendingRecharges,
      duplicateTransactionsGap,
      pendingStatusCheckTime,
      fakeComplaintPenality,

      // Payment Gateway Configuration
      paymentGatewayStatus: paymentGatewayStatus,
      paymentGatewayMinAmount: paymentGatewayMinAmount,
      paymentGatewayMaxAmount: paymentGatewayMaxAmount,

      // Wallet Configuration
      complaintHoldDays,
      sellerAmountHoldPercentage,
      timeBetweenRedeem,
      minAutoWalletTransferAmount: minAutoWalletTransferAmount,
      timeBetweenAutoWalletTransfer: timeBetweenAutoWalletTransfer,
      autoWalletTransferStatus: autoWalletTransferStatus,
      timeBetweenComplaints,
      redeemStatus,
      redeemSameAmountGap,
      minimumRedeemAmountLimit,
      maximumRedeemAmountLimit,
      walletTopUpSameAmountGap,

      // Seller Configuration
      sellersMaxAllowedApis,
      sellersAPIEditStatus,
      sellersAPIDeleteStatus,
      sellersMarginEditStatus,
      sellersMarginDeleteStatus,
      sellersMarginUserCountStatus,
      salesMarginLimit,
      salesMarginUpdateGap,
      salesMarginStockLimit,

      // Recharge Alerts
      transactionPendingWarning,
      complaintPendingWarning,

      // Payout Configuration
      bankVerificationCharges,
      withdrawCharges,
      payoutStatus,

      // User Complaint Settings
      complaintsAllowedTime,
      complaintsAllowedCount,

      // User Api Disable Settings
      apiDisableforComplaintTime,
      apiDisableforPendingTime,
      allowComplaintsAfterRecharge,

      buyerWalletCap,
    };
    API.put(`/configurations/app-configuration`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setOriginalFormData(formData);
          setTimeout(() => {
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          {/* Login Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Login Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Two-Factor Authentication (2FA)</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={twofaStatus === "Active"}
                      onChange={(value) =>
                        setTwofaStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {/* Maintenance */}
          <Fieldset forLegend display="block">
            <Legend>Maintenance</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>API System Maintenance</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={apiSystemMaintenance === "Active"}
                      onChange={(value) =>
                        setApiSystemMaintenance(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Web System Maintenance</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={webSystemMaintenance === "Active"}
                      onChange={(value) =>
                        setWebSystemMaintenance(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem></GridItem>
              <GridItem></GridItem>
            </Grid>
          </Fieldset>

          {/* GST Configuration */}
          <Fieldset forLegend display="block">
            <Legend>GST Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>GST Wallet</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={gstWalletStatus === "Active"}
                      onChange={(value) =>
                        setGstWalletStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              {/* <GridItem>
                <Fieldset>
                  <Label>Non-GST Wallet</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={nonGstWalletStatus === "Active"}
                      onChange={(value) =>
                        setNonGstWalletStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem> */}
              <GridItem>
                <Fieldset>
                  <Label>GST Invoice: P2P</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={gstInvoiceP2PStatus === "Active"}
                      onChange={(value) =>
                        setGstInvoiceP2PStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>GST Invoice: P2A</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={gstInvoiceP2AStatus === "Active"}
                      onChange={(value) =>
                        setGstInvoiceP2AStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem></GridItem>
            </Grid>
          </Fieldset>

          {/* Recharge Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Recharge Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Maximum API Retry Attempts</Label>
                  <NumberInput
                    value={maxRechargeApiHits}
                    onChange={setMaxRechargeApiHits}
                    placeholder="Please enter maximum API retry attempts"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Callback API Failover Time (Minutes)</Label>
                  <NumberInput
                    value={callbackRechargeProcessingTime}
                    onChange={setCallbackRechargeProcessingTime}
                    placeholder="Please enter callback api failover time"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Allowed Complaint Ratio (%) </Label>
                  <NumberInput
                    value={complaintRatioAllowed}
                    onChange={setComplaintRatioAllowed}
                    placeholder="Please enter allowed complaint ratio"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Complaint Calculation Period (Days)</Label>
                  <NumberInput
                    value={complaintCalculationPeriod}
                    onChange={setComplaintCalculationPeriod}
                    placeholder="Please enter complaint calculation period"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Callback Calculation Period (Days)</Label>
                  <NumberInput
                    value={callbackCalculationPeriod}
                    onChange={setCallbackCalculationPeriod}
                    placeholder="Please enter callback calculation period"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Max Pending Recharges</Label>
                  <NumberInput
                    value={maxPendingRecharges}
                    onChange={setMaxPendingRecharges}
                    placeholder="Please enter max pending recharges"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Duplicate Transactions Gap (Minutes)</Label>
                  <NumberInput
                    value={duplicateTransactionsGap}
                    onChange={setDuplicateTransactionsGap}
                    placeholder="Please enter duplicate transactions gap in minutes"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Pending Status Check Time</Label>
                  <NumberInput
                    value={pendingStatusCheckTime}
                    onChange={setPendingStatusCheckTime}
                    placeholder="Please enter pending status check time"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Fake Complaint Penality (%) </Label>
                  <NumberInput
                    value={fakeComplaintPenality}
                    onChange={setFakeComplaintPenality}
                    placeholder="Please enter fake complaint penality"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Roffer Check</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={rofferCheck === "Active"}
                      onChange={(value) =>
                        setRofferCheck(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Operator Validation</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={operatorValidation === "Active"}
                      onChange={(value) =>
                        setOperatorValidation(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem></GridItem>
            </Grid>
          </Fieldset>
          {/* Payment Gateway Configuration */}

          <Fieldset forLegend display="block">
            <Legend>Payment Gateway Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Minimum Transaction Amount</Label>
                  <NumberInput
                    value={paymentGatewayMinAmount}
                    onChange={setPaymentGatewayMinAmount}
                    placeholder="Please enter minimum transaction amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Maximum Transaction Amount</Label>
                  <NumberInput
                    value={paymentGatewayMaxAmount}
                    onChange={setPaymentGatewayMaxAmount}
                    placeholder="Please enter maximum transaction amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Payment Gateway</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={paymentGatewayStatus === "Active"}
                      onChange={(value) =>
                        setPaymentGatewayStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {/* Seller Wallet Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Seller Wallet Configuration</Legend>
            <Grid>
              <GridItem>
                <Label>Funds Hold Duration (Days, on Complaint)</Label>
                <NumberInput
                  value={complaintHoldDays}
                  onChange={setComplaintHoldDays}
                  placeholder="Please enter complaint hold days"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Funds Hold Percentage (%)</Label>
                  <NumberInput
                    value={sellerAmountHoldPercentage}
                    onChange={setSellerAmountHoldPercentage}
                    placeholder="Please enter seller amount hold percentage"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Redeem Requests Gap (Minutes)</Label>
                  <NumberInput
                    value={timeBetweenRedeem}
                    onChange={setTimeBetweenRedeem}
                    placeholder="Please enter time between redeem"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Time Between Complaints (Minutes)</Label>
                  <NumberInput
                    value={timeBetweenComplaints}
                    onChange={setTimeBetweenComplaints}
                    placeholder="Please enter time between complaints"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Redeem Status</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={redeemStatus === "Active"}
                      onChange={(value) =>
                        setRedeemStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Redeem Same Amount Gap (Minutes)</Label>
                  <NumberInput
                    value={redeemSameAmountGap}
                    onChange={setRedeemSameAmountGap}
                    placeholder="Please enter redeem same amount gap"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Minimum Redeem Amount Limit</Label>
                  <NumberInput
                    value={minimumRedeemAmountLimit}
                    onChange={setMinimumRedeemAmountLimit}
                    placeholder="Please enter minimum redeem amount limit"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Maximum Redeem Amount Limit</Label>
                  <NumberInput
                    value={maximumRedeemAmountLimit}
                    onChange={setMaximumRedeemAmountLimit}
                    placeholder="Please enter maximum redeem amount limit"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Automatic Wallet Transfer</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={autoWalletTransferStatus === "Active"}
                      onChange={(value) =>
                        setAutoWalletTransferStatus(
                          value ? "Active" : "Inactive"
                        )
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Auto Transfer Interval (Minutes)</Label>
                  <NumberInput
                    value={timeBetweenAutoWalletTransfer}
                    onChange={setTimeBetweenAutoWalletTransfer}
                    placeholder="Please enter time between auto wallet transfers"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Label>Minimum Auto Transfer Amount</Label>
                <NumberInput
                  value={minAutoWalletTransferAmount}
                  onChange={setMinAutoWalletTransferAmount}
                  placeholder="Please enter min auto wallet transfer amount"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem></GridItem>
            </Grid>
          </Fieldset>

          {/* Buyer Wallet Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Buyer Wallet Configuration</Legend>
            <Fieldset>
              <Label>Wallet Top-Up Same Amount Gap (Minutes)</Label>
              <NumberInput
                value={walletTopUpSameAmountGap}
                onChange={setWalletTopUpSameAmountGap}
                placeholder="Please enter wallet top up same amount gap"
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>Wallet Max Amount</Label>
              <NumberInput
                value={buyerWalletCap}
                onChange={setBuyerWalletCap}
                placeholder="Please enter wallet max amount"
                disabled={isLoading}
              />
            </Fieldset>
          </Fieldset>

          {/* Seller API & Margin Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Seller API & Margin Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Allow Seller to Edit API</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={sellersAPIEditStatus === "Yes"}
                      onChange={(value) =>
                        setSellersAPIEditStatus(value ? "Yes" : "No")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Allow Seller to Delete API</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={sellersAPIDeleteStatus === "Yes"}
                      onChange={(value) =>
                        setSellersAPIDeleteStatus(value ? "Yes" : "No")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Allow Seller to Edit Margin</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={sellersMarginEditStatus === "Yes"}
                      onChange={(value) =>
                        setSellersMarginEditStatus(value ? "Yes" : "No")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Allow Seller to Delete Margin</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={sellersMarginDeleteStatus === "Yes"}
                      onChange={(value) =>
                        setSellersMarginDeleteStatus(value ? "Yes" : "No")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Label>Maximum APIs Allowed per Seller</Label>
                <NumberInput
                  value={sellersMaxAllowedApis}
                  onChange={setSellersMaxAllowedApis}
                  placeholder="Please enter maximum APIs allowed per seller"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Buyer Block Threshold Count</Label>
                  <NumberInput
                    value={sellersMarginUserCountStatus}
                    onChange={setSellersMarginUserCountStatus}
                    placeholder="Please enter buyer block threshold count"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Sales Margin Limit</Label>
                  <NumberInput
                    value={salesMarginLimit}
                    onChange={setSalesMarginLimit}
                    placeholder="Please enter sales margin limit"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Sales Margin Update Gap (Minutes)</Label>
                  <NumberInput
                    value={salesMarginUpdateGap}
                    onChange={setSalesMarginUpdateGap}
                    placeholder="Please enter sales margin update gap"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Sales Margin Stock Limit</Label>
                  <NumberInput
                    value={salesMarginStockLimit}
                    onChange={setSalesMarginStockLimit}
                    placeholder="Please enter sales margin stock limit"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem></GridItem>
              <GridItem></GridItem>
              <GridItem></GridItem>
            </Grid>
          </Fieldset>

          {/* Recharge Alerts */}
          <Fieldset forLegend display="block">
            <Legend>Recharge Alerts</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Transaction Pending Warning (Minutes)</Label>
                  <NumberInput
                    value={transactionPendingWarning}
                    onChange={setTransactionPendingWarning}
                    placeholder="Please enter transaction pending warning"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Complaint Pending Warning (Minutes)</Label>
                  <NumberInput
                    value={complaintPendingWarning}
                    onChange={setComplaintPendingWarning}
                    placeholder="Please enter complaint pending warning"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {/* Payout Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Payout Configuration</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Bank Verification Fee</Label>
                  <NumberInput
                    value={bankVerificationCharges}
                    onChange={setBankVerificationCharges}
                    placeholder="Please enter bank verification fee"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Redeem Charges</Label>
                  <NumberInput
                    value={withdrawCharges}
                    onChange={setWithdrawCharges}
                    placeholder="Please enter redeem charges"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Payout</Label>
                  <StyledSwitchOuter>
                    <Switch
                      value={payoutStatus === "Active"}
                      onChange={(value) =>
                        setPayoutStatus(value ? "Active" : "Inactive")
                      }
                    />
                  </StyledSwitchOuter>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {/* User Complaint Settings */}
          <Fieldset forLegend display="block">
            <Legend>User Complaint Settings</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Complaint Window (Minutes)</Label>
                  <NumberInput
                    value={complaintsAllowedTime}
                    onChange={setComplaintsAllowedTime}
                    placeholder="Please enter complaint window"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Maximum Complaints Allowed</Label>
                  <NumberInput
                    value={complaintsAllowedCount}
                    onChange={setComplaintsAllowedCount}
                    placeholder="Please enter maximum complaints allowed"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Allow Complaints After Recharge (Minutes)</Label>
                  <NumberInput
                    value={allowComplaintsAfterRecharge}
                    onChange={setAllowComplaintsAfterRecharge}
                    placeholder="Please enter allow complaints after recharge"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {/* User API Suspension Settings */}
          <Fieldset forLegend display="block">
            <Legend>User API Suspension Settings</Legend>
            <Fieldset>
              <Label>Suspend API After Complaints Delay (Minutes)</Label>
              <NumberInput
                value={apiDisableforComplaintTime}
                onChange={setApiDisableforComplaintTime}
                placeholder="Please enter suspend API after complaints delay"
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>Suspend API After Pending Delay (Minutes)</Label>
              <NumberInput
                value={apiDisableforPendingTime}
                onChange={setApiDisableforPendingTime}
                placeholder="Please enter suspend API after pending delay"
                disabled={isLoading}
              />
            </Fieldset>
          </Fieldset>

          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <UpdateButton disabled={isLoading} type="submit">
              Update
            </UpdateButton>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(AppConfiguration);
